import { config } from '@uhg-abyss/web/tools/config';
import { storage } from '@uhg-abyss/web/tools/storage';

import { Constants } from '../../common/Constants';
import { useCustomQuery } from '../useCustomQuery';
import GET_CARE_TEAM from './GetCareTeam.graphql';
import GET_CARE_TEAM_PAGINATED from './GetCareTeamPaginated.graphql';
import SAVE_CARE_TEAM from './SaveCareTeam.graphql';

// Guest sessions have no real member identity, so Care Team APIs would fail downstream.
const isGuestUser = () =>
  !!storage.session.get(Constants.STORAGE_KEYS.SESSION.IS_GUEST);

const withGuestGuard = (queryAction, options, guestResult) => (params) => {
  if (!isGuestUser()) {
    return queryAction(params);
  }
  options?.onCompleted?.(guestResult);
  return Promise.resolve(guestResult);
};

export const useSaveCareTeam = (options) => {
  const [queryResult, queryAction] = useCustomQuery(SAVE_CARE_TEAM, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'saveCareTeam',
    requestPolicy: 'no-cache',
  });

  return [
    queryResult,
    withGuestGuard(queryAction, options, { data: { saveCareTeam: null } }),
  ];
};

export const useGetCareTeam = (options) => {
  const [queryResult, queryAction] = useCustomQuery(GET_CARE_TEAM, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getCareTeam',
    //TODO: Need to check if this is required or not
    requestPolicy: 'no-cache',
  });

  const parsedResult = {
    ...queryResult,
    data: {
      getCareTeam: {
        ...queryResult?.data?.getCareTeam,
        chipWithCount: queryResult?.data?.getCareTeam?.chipWithCount?.reduce(
          (acc, { chip, count }) => ({ ...acc, [chip]: count }),
          {}
        ),
      },
    },
  };

  return [
    parsedResult,
    withGuestGuard(queryAction, options, {
      data: { getCareTeam: { chipWithCount: [], providerIds: [] } },
    }),
  ];
};

export const useGetCareTeamPaginated = (options) => {
  const [queryResult, queryAction] = useCustomQuery(GET_CARE_TEAM_PAGINATED, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getCareTeamPaginated',
    requestPolicy: 'no-cache',
  });
  const parsedResult = {
    ...queryResult,
    data: {
      ...queryResult?.data?.getCareTeamPaginated,
    },
  };
  return [
    parsedResult,
    withGuestGuard(queryAction, options, {
      data: { getCareTeamPaginated: { careTeamProviders: [], totalCount: 0 } },
    }),
  ];
};
